<template>
  <section class="records-section">
    <h2 class="section-title">质押记录</h2>
    <div class="table-card">
      <div class="table-header">
        <span v-for="col in columns" :key="col.key" class="col" :class="col.key">
          {{ col.label }}
        </span>
      </div>
      <div v-if="loading" class="empty-row">加载中...</div>
      <div v-else-if="records.length === 0" class="empty-row">暂无质押记录</div>
      <div v-for="record in records" :key="record.id" class="table-row">
        <span class="col time">{{ record.remainingTime }}</span>
        <span class="col type">{{ record.type }}</span>
        <span class="col amount">{{ record.amount }}</span>
        <span class="col lp">{{ record.lpAmount }}</span>
        <span class="col reward">{{ record.reward }}</span>
        <span class="col action">
          <button
            class="redeem-btn"
            :class="{ disabled: !record.canRedeem }"
            :disabled="!record.canRedeem"
            @click="onRedeem(record)"
          >
            赎回
          </button>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    records: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        { key: "time", label: "剩余时间" },
        { key: "type", label: "类型" },
        { key: "amount", label: "金额(USDT)" },
        { key: "lp", label: "lp数量" },
        { key: "reward", label: "收益(RUSD)" },
        { key: "action", label: "操作" },
      ],
    };
  },
  methods: {
    onRedeem(record) {
      if (!record.canRedeem) return;
      this.$emit("redeem", record);
    },
  },
};
</script>

<style lang="scss" scoped>
.records-section {
  padding: 0 30px 24px;
}

.section-title {
  margin: 0 0 16px;
  font-size: 30px;
  color: #fff;
}

.table-card {
  padding: 16px 12px;
  border-radius: 16px;
  background: #040a28;
  overflow-x: auto;
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 1.2fr 0.9fr 1.1fr 0.9fr;
  gap: 8px;
  min-width: 600px;
  align-items: center;
}

.table-header {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .col {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    white-space: nowrap;
  }
}

.table-row {
  padding: 20px 0;

  &:last-child {
    margin-bottom: 0;
  }

  .col {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    white-space: nowrap;
  }
}

.empty-row {
  padding: 24px 0;
  text-align: center;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.5);
}

.redeem-btn {
  min-width: 84px;
  height: 40px;
  padding: 0 30px;
  border: none;
  border-radius: 20px;
  font-size: 22px;
  color: #fff;
  background: #7338ff;
  cursor: pointer;
  transition: opacity 0.2s;

  &.disabled {
    background: rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.4);
    cursor: not-allowed;
  }

  &:not(.disabled):hover {
    opacity: 0.9;
  }
}
</style>
